import { gql } from "@apollo/client"

// NORMEN
export const IMPORT_NORMEN = gql`
  mutation ImportNormenFromExcel($input: NormenImportInput!) {
    importNormenFromExcel(input: $input)
  }
`
